var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoucoSatisfeito(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 871,
    height: 871,
    viewBox: "0 0 871 871",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_63533",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 871,
    height: 871
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M870.852 0H0V870.852H870.852V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_63533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M768.027 434.973C768.027 618.583 619.18 767.428 435.572 767.428C251.962 767.428 103.117 618.583 103.117 434.973C103.117 251.363 251.962 102.519 435.572 102.519C619.18 102.519 768.027 251.363 768.027 434.973Z",
    fill: "url(#paint0_linear_14_63533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.996 436.226C729.432 603.494 594.683 737.058 431.025 734.548C267.367 732.039 136.774 594.412 139.338 427.144C141.902 259.876 276.651 126.314 440.31 128.822C603.967 131.332 734.56 268.96 731.996 436.226Z",
    fill: "url(#paint1_radial_14_63533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.027 434.973C768.027 618.583 619.18 767.428 435.572 767.428C251.962 767.428 103.117 618.583 103.117 434.973C103.117 251.363 251.962 102.519 435.572 102.519C619.18 102.519 768.027 251.363 768.027 434.973Z",
    stroke: "#E76900",
    strokeWidth: 10.2992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.201 632.866C494.256 611.425 461.329 594.322 435.423 594.322C409.475 594.322 376.658 611.425 356.715 632.866C338.598 652.34 337.198 670.353 343.086 672.617C350.48 675.461 382.766 646.172 435.423 645.606C488.078 646.172 520.361 675.461 527.755 672.617C533.643 670.353 532.315 652.34 514.201 632.866Z",
    fill: "#FEDD78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.787 615.104C488.841 593.663 461.328 576.56 435.422 576.56C409.474 576.56 382 593.663 362.056 615.104C343.941 634.578 337.199 663.332 343.086 665.596C350.48 668.441 382.766 626.439 435.422 625.872C488.078 626.439 520.362 668.441 527.756 665.596C533.642 663.332 526.901 634.578 508.787 615.104Z",
    fill: "#EAAC1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.787 625.67C488.841 604.229 461.328 587.127 435.422 587.127C409.474 587.127 382 604.229 362.056 625.67C343.941 645.144 337.199 663.157 343.086 665.422C350.48 668.266 382.766 636.761 435.422 636.194C488.078 636.761 520.362 668.266 527.756 665.422C533.642 663.157 526.901 645.144 508.787 625.67Z",
    fill: "#974800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.434 665.043C525.721 657.54 519.098 646.939 508.778 635.861C488.842 614.427 461.334 599.069 435.427 599.069C409.466 599.069 382.01 614.427 362.056 635.861C351.754 646.939 345.131 657.54 342.42 665.043C337.787 661.644 344.691 644.331 362.056 625.663C382.01 604.23 409.466 587.129 435.427 587.129C461.334 587.129 488.842 604.23 508.778 625.663C526.142 644.331 533.065 661.644 528.434 665.043Z",
    fill: "#632900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.346 467.533C229.698 488.551 200.384 470.818 207.666 502.412C213.596 528.143 264.568 523.518 308.32 507.36C348.475 492.531 382.573 468.85 374.311 445.77C366.256 423.268 326.333 452.696 286.346 467.533Z",
    fill: "#FDE59C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.316 456.834C229.7 477.944 206.21 469.419 206.152 492.85C206.09 518.133 271.186 511.853 304.344 498.366C330.231 487.837 386.144 456.98 371.092 437.724C347.15 407.095 331.172 437.994 283.316 456.834Z",
    fill: "#EAAC1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.292 469.368C255.932 481.853 210.113 478.923 212.903 499.511C215.679 519.998 277.435 511.852 305.667 499.06C327.516 489.159 379.649 465.698 363.958 446.469C346.202 424.711 311.913 459.568 287.292 469.368Z",
    fill: "#974800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.215 465.112C251.012 478.51 228.185 476.996 217.457 486.73C206.2 496.946 217.948 505.939 218.174 507.953C216.819 488.171 251.959 489.687 286.824 476.945C328.045 461.879 347.53 429.636 363.811 462.678C365.526 459.662 370.652 451.372 358.276 440.508C342.226 426.417 313.131 454.176 285.215 465.112Z",
    fill: "#632900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.142 467.533C640.79 488.551 670.104 470.818 662.822 502.412C656.892 528.143 605.92 523.518 562.168 507.36C522.014 492.531 487.915 468.85 496.178 445.77C504.232 423.268 544.155 452.696 584.142 467.533Z",
    fill: "#FDE59C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.172 456.834C640.788 477.944 664.278 469.419 664.336 492.85C664.398 518.133 599.302 511.853 566.144 498.366C540.257 487.837 484.345 456.98 499.396 437.724C523.338 407.095 539.316 437.994 587.172 456.834Z",
    fill: "#EAAC1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.196 469.368C614.556 481.853 660.375 478.923 657.585 499.511C654.809 519.998 593.053 511.852 564.821 499.06C542.972 489.159 490.839 465.698 506.531 446.469C524.286 424.711 558.576 459.568 583.196 469.368Z",
    fill: "#974800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.274 465.112C619.477 478.51 642.303 476.996 653.031 486.73C664.288 496.946 652.54 505.939 652.314 507.953C653.669 488.171 618.529 489.687 583.664 476.945C542.443 461.879 522.958 429.636 506.677 462.678C504.962 459.662 499.837 451.372 512.212 440.508C528.263 426.417 557.357 454.176 585.274 465.112Z",
    fill: "#632900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_63533",
    x1: 433.799,
    y1: 134.055,
    x2: 437.209,
    y2: 757.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5AB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ED8700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14_63533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(425.369 158.689) scale(584.23 584.23)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FEFEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FDEE8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCDE36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F5B820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE910A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoucoSatisfeito);
export default __webpack_public_path__ + "static/media/pouco-satisfeito.9e55ba48945dc7c500e996b2a61ad107.svg";
export { ForwardRef as ReactComponent };